import { render, staticRenderFns } from "./PatentIcon.vue?vue&type=template&id=26dbad56"
import script from "./PatentIcon.vue?vue&type=script&lang=js"
export * from "./PatentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports